export const DarkBg = ({ children}) => {
    return (
        <div className="dark-bg">
            {children}
        </div>
    )
}